<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="IP地址" class="a_input_self margin_self" v-model="queryParam.ipaddr" />
			<a-input placeholder="用户名" class="a_input_self margin_self" v-model="queryParam.loginName" />
			<a-select placeholder="状态" class="a_input_self margin_self" v-model="queryParam.status" default-value="0">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(d, index) in commonStatus" :key="index" :value="d.dictValue">{{ d.dictLabel }}</a-select-option>
			</a-select>
			<a-range-picker v-model="range" class="margin_self" :placeholder="['登录开始日期', '登录结束日期']" />
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
			<!-- <a-popconfirm v-has="'monitor:logininfor:remove'" title="确认清空吗？" @confirm="clean">
				<a-icon slot="icon" type="question-circle-o" style="color: red" />
				<a-button type="danger" ghost icon="close">清空</a-button>
			</a-popconfirm> -->
			<!-- <a-dropdown v-has="'monitor:logininfor:remove'" v-if="selectedRowKeys.length > 0">
				<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
			</a-dropdown> -->
		</div>

		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<s-table size="default" ref="table" rowKey="infoId" 
			 :columns="columns" :data="loadData" :rangPicker="range" defaultSort="loginTime" :scroll="{  y: scroll_y }">
				<span slot="status" slot-scope="text">
					{{ text | statusFilter }}
				</span>
			</s-table>
		</div>
	</div>
</template>

<script>
	import {
		STable
	} from '@/components'
	import { getLoginLogList, delLoginLog, cleanLoginLog } from '@/api/monitor'
	import {
		getDictArray
	} from '../../utils/dict'
	const commonStatusMap = {}
	export default {
		name: 'TableList',
		components: {
			STable
		},
		data() {
			return {
				scroll_y: 150,
				visible: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					}
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					}
				},
				form: this.$form.createForm(this),
				mdl: {},
				permissions: [],
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '记录编号',
						dataIndex: 'infoId',
						ellipsis: true,
					},
					{
						title: '用户名',
						dataIndex: 'loginName',
						ellipsis: true,
					},
					{
						title: '登录时间',
						dataIndex: 'loginTime',
						sorter: true,
						ellipsis: true,
						width:200,
					},
					{
						title: 'IP地址',
						dataIndex: 'ipaddr',
						ellipsis: true,
					},
					
					{
						title: '地点',
						dataIndex: 'loginLocation',
						ellipsis: true,
					},
					{
						title: '浏览器',
						dataIndex: 'browser',
						ellipsis: true,
					},
					{
						title: '操作系统',
						dataIndex: 'os',
						ellipsis: true,
					},
					{
						title: '登录方式',
						dataIndex: 'loginType',
						ellipsis: true,
					},
					{
						title: '登录状态',
						dataIndex: 'status',
						scopedSlots: {
							customRender: 'status'
						}
					},
					{
						title: '登录反馈',
						dataIndex: 'msg',
						ellipsis: true,
					},
					
				],
				range: null,
				// 加载数据方法 必须为 Promise 对象
				loadData: parameter => {
					return getLoginLogList(Object.assign(parameter, this.queryParam))
				},
				commonStatus: [],
				selectedRowKeys: [],
				selectedRows: []

			}
		},
		filters: {
			operTypeFilter(type) {
				return commonStatusMap[type].text
			},
			statusFilter(status) {
				const statusMap = {
					'1': '失败',
					'0': '成功'
				}
				return statusMap[status]
			}
		},
		beforeCreate() {

		},
		async created() {
			this.commonStatus = await getDictArray('sys_common_status')
			this.commonStatus.map(d => {
				commonStatusMap[d.dictValue] = {
					text: d.dictLabel
				}
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $(".ant-table-header").height()-50;
				}, 1000);
			})
		},
		methods: {
			onSelectChange(selectedRowKeys, selectedRows) {
				this.selectedRowKeys = selectedRowKeys
				this.selectedRows = selectedRows
			},
			handleOk() {
				this.$refs.table.refresh(true)
			},
			delByIds(ids) {
				delLoginLog({ ids: ids.join(',') }).then(res => {
				  if (res.code === 200) {
				    this.$message.success(`删除成功`)
				    this.handleOk()
				  } else {
				    this.$message.error(res.msg)
				  }
				  this.selectedRowKeys = []
				})
			},
			// clean() {
			// 	cleanLoginLog().then(res => {
			// 	  this.handleOk()
			// 	})
			// }
		},
		watch: {
			
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			 
		}
	}
</script>
